import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import WithLabel, { LABEL_STYLES } from '../../../../../components/with-label/WithLabel';
import SearchInput from '../../../../../components/common-inputs/SearchInput';
import { changeSessionsTableSettings } from '../../../../../redux/story/storyReducer';

import scss from './SessionFilters.module.scss';

function SessionFilters({ isAdmin }) {
  const { t } = useTranslation('story');
  const dispatch = useDispatch();

  const username = useSelector((state) => state.story.sessionsTableSettings.username);

  const handleChangeUsername = (value) => {
    dispatch(changeSessionsTableSettings({ username: value, page: 0 }));
  };

  return null;

  // if (!isAdmin) {
  //   return null;
  // }

  // return (
  //   <div className={scss.wrapper}>
  //     <WithLabel label={t('user')} variant={LABEL_STYLES.COLUMN} isBold>
  //       <SearchInput size='sm' value={username} onChange={handleChangeUsername} placeholder={t('searchUser')} />
  //     </WithLabel>
  //   </div>
  // );
}

export default SessionFilters;
